import { colors } from '@mui/material'
import { createTheme } from '@mui/material/styles'
import { PaletteColorOptions } from '@mui/material/styles'

export const ecolors = {
  midgrey: colors.grey[400],
}

declare module '@mui/material/styles' {
  interface Palette {
    normalGrey: Palette['primary']
    lightGrey: Palette['primary']
    reportBg: Palette['primary']
  }

  interface PaletteOptions {
    normalGrey?: PaletteColorOptions
    lightGrey?: PaletteColorOptions
    reportBg?: PaletteColorOptions
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#10a37f', //tail
    },
    normalGrey: {
      main: '#8a8a8a',
    },
    lightGrey: {
      main: '#f9f8f8',
    },
    reportBg: {
      main: '#FCFCFC',
    },
    background: {
      default: 'white',
    },

    text: {
      primary: 'rgb(25, 27, 32)',
    },
  },

  typography: {
    fontSize: 15,

    allVariants: {
      fontFamily: 'Inter',
      fontWeight: 400,
    },
    h1: {
      fontSize: '2.6rem',
      fontWeight: 600,
      letterSpacing: '1.5px',
    },
    h4: {
      fontWeight: 600,
    },
  },

  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          letterSpacing: '0',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          // fontSize: '14px',
        },
      },
    },

    MuiStack: { defaultProps: { useFlexGap: true } },
    MuiPaper: {
      styleOverrides: {
        root: {
          color: '#212636',
          overflow: 'hidden',
          transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          width: '100%',
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          backgroundColor: '#f9fafb',
          color: '#667085',
          lineHeight: '1',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #dcdfe4',
          fontSize: '0.750rem',
          fontWeight: '400',
          lineHeight: '1.10',
        },
        head: {
          backgroundColor: '#f9fafb',
          color: '#667085',
          fontWeight: '500',
          lineHeight: '1.15',
        },
      },
    },
  },
})

export default theme
